/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { InteractiveComponents } from '../../../../core/enums';
import { RootState, useTivoSelector } from '../../../../core/tivo/tivo-redux-wrapper';
import { Caret } from '../../../common';

import './OnePassManagerInteractiveLayer.scss';

interface IOnePassManagerInteractiveLayerProps {
    focused: boolean;
}

const OnePassManagerInteractiveLayer: FunctionComponent<IOnePassManagerInteractiveLayerProps> = ({
    focused,
}): JSX.Element => {
    const activeComponent = useTivoSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );

    return (
        <React.Fragment>
            <Caret
                className={'onepass-caret caret-north'}
                direction={InteractiveComponents.NORTH}
                visible={focused && activeComponent === InteractiveComponents.NORTH}
                active={activeComponent === InteractiveComponents.NORTH}
            />
            <Caret
                className={'onepass-caret caret-south'}
                direction={InteractiveComponents.SOUTH}
                visible={focused && activeComponent === InteractiveComponents.SOUTH}
                active={activeComponent === InteractiveComponents.SOUTH}
            />
        </React.Fragment>
    );
};

export default OnePassManagerInteractiveLayer;
